exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1XzASvwMqOloAOGuiJD-5M {\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n  margin: 16px 8px 8px;\n}\n\n._2bzx4RYFRaj1Eerrh6QfOR {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n._2bzx4RYFRaj1Eerrh6QfOR > div {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n._2Q_UTQFYA8lOBe0yCFUJWm {\n  cursor: pointer;\n}\n\n._1NfkE_GTZtr1I-wnwz5ovr {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 2px;\n}\n", ""]);

// Exports
exports.locals = {
	"trackingActions": "_1XzASvwMqOloAOGuiJD-5M",
	"detailRows": "_2bzx4RYFRaj1Eerrh6QfOR",
	"relatedCallCard": "_2Q_UTQFYA8lOBe0yCFUJWm",
	"relatedCallHeader": "_1NfkE_GTZtr1I-wnwz5ovr"
};